<template>
    <v-dialog max-width="720px" v-model="getModalCadastroGrupoPermissao">
        <v-card outlined :loading="$store.getters.getOverlay">
            <Alert />
            <v-card-title>
                Cadastro de Grupo de Permissão
            </v-card-title>
            <v-form ref="form" class="px-3">
                <v-card-text>
                    <v-layout row wrap class="">
                        <v-flex xs12 md12>
                        <v-text-field dense label="Nome" class="ml-2 mr-2" outlined v-model="getGrupoPermissao.nome" :rules="rules.nome" @keyup.13="salvar"></v-text-field>
                        </v-flex> 
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="success" @click="salvar" outlined :loading="$store.getters.getOverlay">Salvar</v-btn>
                    <v-btn v-if="getGrupoPermissao.id" color="primary" @click="cadastrarGrupoPermissao" outlined>Novo</v-btn>
                    <v-btn v-if="getGrupoPermissao.id" color="error" @click.stop="setModalExcluirGrupoPermissao(true)" outlined>Excluir</v-btn>
                    <v-btn class="white--text" color="blue-grey" @click="setModalCadastroGrupoPermissao(false)" outlined>Voltar</v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
        
        <ModalExcluirGrupoPermissao />
    </v-dialog>
</template>

<script>
    import ModalExcluirGrupoPermissao from "@/pages/perfil/grupoPermissao/ModalExcluir"
    import { mapGetters, mapActions } from 'vuex'
    export default {
        components: {
            ModalExcluirGrupoPermissao
        },
        data(){
            return {
                rules: {
                    nome: [
                        v => !!v || 'Campo obrigatório.'
                    ],
                    
                }
            }
        },
        computed: {
            ...mapGetters([
            'getGrupoPermissao',
            'getModalCadastroGrupoPermissao',
            ])
        },
        methods: {
            ...mapActions([
            'setModalCadastroGrupoPermissao',
            'setModalExcluirGrupoPermissao',
            'cadastrarGrupoPermissao',
            'salvarGrupoPermissao',
            'atualizarGrupoPermissao'
            ]),
            salvar(){
                if(this.$refs.form.validate()){
                    if(this.getGrupoPermissao.id){
                        this.atualizarGrupoPermissao(this.getGrupoPermissao)
                    }else{
                        this.salvarGrupoPermissao(this.getGrupoPermissao)
                    }
                }
                
            },
        }
    }
</script>